import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom'
import { Button } from '../atoms/button';
import { Label } from '../atoms/label';
import { Image } from '../atoms/image';
import useMedia from 'use-media';
import { Explanation } from '../molecules/explanation';
import { Line } from '../atoms/line';
import { ExplanationPre } from '../molecules/explanationPre';
import { ModalClose } from '../atoms/modalClose';
import '../../resources/css/reserve/reserve.css';


const GolfSearchResultsDetailContainer = (props) => {

    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const numberWithComma = new Intl.NumberFormat();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const price = (plan) => {

        if (plan.plansets == null) {
            return "";
        }
        let price = plan.plansets[0].priceTotal;
        plan.plansets.forEach((planset) => {
            price = price <= planset.priceTotal ? price : planset.priceTotal
        });
        return price != null ? `￥${numberWithComma.format(price)}～` : "";
    }

    let notification;
    if (props.plan.notification !== undefined) {
        notification = props.plan.notification.replaceAll("<br>", "\r\n");
    }
    const data = {
        planId: props.facility.golfCourseID,
        imageTop: props.facility.image_path,
        hotelName: props.facility.name,
        planName: props.plan.planname,
        planDetail: props.plan.remark,
        memberPrice: price(props.plan),
        //guestPrice: props.plan.guestPrice != null ? `￥${numberWithComma.format(Number(props.plan.guestPrice))}～`: "",
        precautions: props.plan.remark,
        notification: notification,
        cancelPrice: props.plan.cancelPriceDescription,
    };

    const history = useHistory();
    const [closeFlg, setCloseFlg] = useState(false);
    const toTerms = () => {
        history.push("/termsOfUse2");
    }

    const popClose = () => {
        props.setState(false);
        setCloseFlg(true);
    }
    const popCancel = () => {
        props.setState(false);
        setCloseFlg(true);
    }
    const popOk = () => {
        // OKクリック時処理
    }

    return (
        <div style={!closeFlg ? styles.container : styles.popNone}>
            <div style={isMobilePhone ? styles.spContent : styles.content}>
                <div style={styles.top}>
                    <div style={isMobilePhone ? styles.spHeader : styles.header}>
                        <Label label="プラン詳細" style={styles.popTitle} />
                        <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={popClose} />
                    </div>
                    <div style={{ height: 75 }} />
                    <div>
                        <div><Image image={data.imageTop} style={isMobilePhone ? styles.imageSP : styles.image} /></div>
                        <div style={styles.popBody}>
                            <Label label={data.hotelName} style={styles.hotelName} />
                            <Line style={styles.lineStyle} />
                            <Explanation title="プラン名" value={data.planName} />
                            <Line style={styles.lineStyle} />
                            {/* <Explanation title="プラン内容" value={data.planDetail} />
                            <Line style={styles.lineStyle} /> */}
                            {data.planId === props.kaiinken ?
                                <div style={styles.member} >
                                    <Label label="おひとり様の料金" style={styles.title} />
                                    <div>
                                        <Label label="メンバー" style={styles.titlePrice} />
                                        <Label label={data.memberPrice} style={styles.valuePrice} />
                                    </div>
                                    <Line style={styles.lineStyle} />
                                </div>
                                : null}
                            {data.notification !== "" && data.notification !== undefined ?
                                <div>
                                    <ExplanationPre value={data.notification} />
                                    <Line style={styles.lineStyle2} />
                                </div>
                                : null}
                            {isMobilePhone ?
                                <Explanation title="キャンセル料" value={data.cancelPrice} />
                                :
                                <ExplanationPre title="キャンセル料" value={data.cancelPrice} />
                            }
                        </div>
                    </div>
                    <div style={{ height: 85 }} />
                    <div style={isMobilePhone ? styles.spBtnArea : styles.BtnArea}>
                        <Button buttonText="予約する" className={isMobilePhone ? "popBtnReservationSp btnPlanDetailReserveIcon btnPlanDetailReserve" : "popBtnReservation"} onClick={() => props.onClick(props.parentIndex, props.index, props.detailPlanType)} />
                    </div>
                </div>
            </div>
        </div>
    );
}
const styles = {
    container: {
        //position:"absolute",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        height: "100%",
        width: "100%",
        zIndex: "100",
        backgroundColor: "rgba(0,0,0,0.8)",
        display: 'flex',
        alignItems: "center"
    },
    content: {
        position: "absolute",
        zIndex: 2000,
        right: "10%",
        width: "80%",
        backgroundColor: "white",
        overflow: "auto",
        height: "90%",
        margin: "0,30%,0,30%",
    },
    spContent: {
        position: "absolute",
        zIndex: 2000,
        // right: "10%",
        top: 50,
        width: "100%",
        backgroundColor: "white",
        overflow: "auto",
        height: "100%",
        margin: "0,30%,0,30%",
    },
    top: {
        // marginLeft:"5%",
        // marginRight:"5%",
        marginBottom: 70
    },
    topSP: {
        margin: "0%",
    },
    spHeader: {
        width: "100%",
        padding: "inherit",
        background: "white",
        position: "fixed",
        height: 75,
        borderBottom: "1px solid gray"
    },
    header: {
        width: "80%",
        padding: "inherit",
        background: "white",
        position: "fixed",
        height: 75,
    },
    popTitle: {
        paddingTop: "20px",
        textAlign: "center",
        cursor: "pointer",
        margin: "0",
        width: "100px",
    },
    closeLink: {
        position: "absolute",
        right: "15px",
        top: "0",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "50px",
        color: "#A5A5A5",
    },
    popTitle: {
        fontWeight: "bold",
        textAlign: "center",
        margin: "30px",
    },
    popBody: {
        marginLeft: "5%",
        marginRight: "5%",
    },
    lineStyle: {
        borderTop: "1px solid rgb(173, 173, 173);",
        margin: "auto",
        display: "flex",
    },
    lineStyle2: {
        borderTop: "1px solid rgb(173, 173, 173);",
        margin: "auto",
        display: "flex",
        marginTop:"10px",
    },
    image: {
        display: "block",
        marginBottom: "3%",
        width: "100%",
    },
    imageSP: {
        display: "block",
        width: "100%",
    },
    hotelName: {
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "serif",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "large",
        width: "100%",
    },
    title: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "30px",
        fontSize: "small",
        width: "100%",
    },
    member: {
        // paddingBottom: "20px",
    },
    titlePrice: {
        paddingRight: "10px",
        display: "inline-block",
        fontSize: "small",
        paddingBottom: "20px",
    },
    valuePrice: {
        display: "inline-block",
        fontWeight: "bold",
        fontsize: "small",
    },
    spBtnArea: {
        height: 75,
        position: "fixed",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bottom: 0,
        background: "white",
        borderTop: "solid 1px #ddd"
    },
    BtnArea: {
        height: 75,
        position: "fixed",
        width: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bottom: "5%",
        background: "white",
        borderTop: "solid 1px #ddd",
    }
}

const mapStateToProps = (state) => {
    return {
        facility: state.facility,
        plan: state.plan,
    };
};

export default connect(mapStateToProps, null)(GolfSearchResultsDetailContainer);